import { render, staticRenderFns } from "./EditComplete.vue?vue&type=template&id=80200866&lang=pug&"
import script from "./EditComplete.vue?vue&type=script&lang=ts&"
export * from "./EditComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports